import qs from "qs";
import renderIFeelConfigModal from "../../../infrastructure/renders/IFeelConfigModal/render-ifeel-config-modal";
import { showErrorMessage } from "../../commons/show-error-message";
import {
  getLanguage,
  translate as t,
} from "../../../infrastructure/translate/localization";
import {
  editBenefitConfig,
  getBenefitDetails,
} from "../../../infrastructure/repository/benefit-repository";
import { hideModal } from "../../commons/hide-modal";
import { showSuccessMessage } from "../../commons/show-success-message";
import { displayBenefitPage } from "../displays/display-benefit-page";
import { findRecurrentPayments } from "../../../infrastructure/repository/recurrent-payments-repository";

export default async function configIFeelBenefit({
  companyId,
  modelId,
  wellnessConfig,
}) {
  renderIFeelConfigModal({ data: {}, callback: () => {}, isLoading: true });
  try {
    const {
      data: { content: data },
    } = await getBenefitDetails({
      companyId,
      category: "wellness",
      vendorId: wellnessConfig?.[0]?.vendorId,
      query: qs.stringify({ language: getLanguage() }),
    });
    const {
      data: { content: recurrentPayments },
    } = await findRecurrentPayments({
      companyId,
      params: qs.stringify({
        category: "wellness-benefit",
        state: "started",
        modelId,
      }),
    });
    const mergedProducts = wellnessConfig?.[0]?.products.map(
      ({ productId, ...rest }) => {
        return {
          ...data.products.find(({ id }) => id === productId),
          ...rest,
        };
      }
    );
    const mergedData = {
      ...data,
      ...wellnessConfig?.[0],
      products: mergedProducts,
    };
    const action = async ({ payload }) => {
      try {
        await editBenefitConfig({
          companyId,
          benefitModelId: modelId,
          category: "wellness",
          benefitConfigId: payload.benefitConfigId,
          payload: {
            ...payload,
            id: payload.benefitConfigId,
          },
        });
        showSuccessMessage(t("benefits-section.benefit-edited-successfully"));
        hideModal();
        displayBenefitPage(modelId);
      } catch (err) {
        showErrorMessage(
          t("benefits-section.an-error-occurred-while-editing-the-benefit")
        );
      }
    };
    renderIFeelConfigModal({
      data: mergedData,
      callback: action,
      productsWithRecurrentPayments: recurrentPayments.map(
        ({ benefitDetails: { productId } }) => productId
      ),
    });
  } catch (err) {
    showErrorMessage(
      t("benefits-section.an-error-occurred-while-retrieving-the-benefit-data")
    );
    hideModal();
  }
}
